import React from 'react';

const COPY = {
  missing: {
    title: "You'll need an invite",
    body: "Grove's in a private trial right now — ask whoever pointed you here for an invite link.",
  },
  invalid: {
    title: 'That invite link has expired',
    body: "This invite has already been used up or is no longer active. Ask whoever sent it for a fresh link.",
  },
};

export default function InviteGateScreen({ reason = 'missing', onSignOut }) {
  const { title, body } = COPY[reason] || COPY.missing;

  return (
    <div className="landing-screen">
      <div className="landing-screen__hero">
        <div className="landing-screen__pitch">
          <h1>Grove</h1>
        </div>

        <div className="signin-card">
          <img src="/grove-logo.png" alt="Grove" className="signin-card__logo" />
          <p className="invite-gate__title">{title}</p>
          <p className="signin-card__sub">{body}</p>
          {onSignOut && (
            <button className="btn" onClick={onSignOut}>Sign out</button>
          )}
        </div>
      </div>

      <div className="landing-screen__footer">
        <a href="/about">About</a>
        <a href="/privacy">Privacy</a>
        <a href="/terms">Terms</a>
      </div>
    </div>
  );
}
